"use client";

import React, { useState } from "react";
import { Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const highlightImages = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631141/img/bento_porsche_track_action.png",
  alt: "High-speed track action shot of a Porsche 911",
  spanClass: "md:col-span-2 md:row-span-2"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631141/img/bento_engine_bay_precision.png",
  alt: "Detailed close-up of a high-performance engine bay",
  spanClass: "md:col-span-1 md:row-span-1"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631141/img/bento_classic_mustang_dusk.png",
  alt: "Classic Mustang side profile at dusk",
  spanClass: "md:col-span-1 md:row-span-2"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631141/img/bento_luxury_interior_wheel.png",
  alt: "Driver's perspective of a luxury sports car interior",
  spanClass: "md:col-span-2 md:row-span-1"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631141/img/bento_city_night_blur.png",
  alt: "Motion blur shot of a car driving through a neon-lit city",
  spanClass: "md:col-span-1 md:row-span-1"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631141/img/bento_carbon_fiber_macro.png",
  alt: "Macro photography of carbon fiber weave texture",
  spanClass: "md:col-span-1 md:row-span-1"
}];
export default function PitStopHighlights() {
  const [selectedImage, setSelectedImage] = useState<{
    src: string;
    alt: string;
  } | null>(null);
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}